import { combineReducers } from 'redux';
import * as fromData from './data/reducers';
import * as fromLogin from './login/reducers';
import { IQuinoState } from '../state';

export const quinoReducer = combineReducers<IQuinoState>({
    data: fromData.reducer,
    login: fromLogin.reducer,
});
